import axios from 'axios';
import { projectDefaultIsochrone } from '@/isochrones';
import { MapStore } from '@/store/map';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';

const mapStore = getModule(MapStore, store);

const getPoints = async (value: string): Promise<any> => {
  const params: any = {};
  if (value === 'big-enterprises') {
    params.size = 'big';
    value = 'enterprises';
  } else if (value === 'small-medium-enterprises') {
    params.size = 'small_medium';
    value = 'enterprises';
  } else if (['primaire', 'lycee', 'college'].includes(value)) {
    params.category = value;
    params['intersects_geom'] = projectDefaultIsochrone().minified;
    value = 'schools';
  } else if (['generalist', 'specialist', 'dentist'].includes(value)) {
    params.profession = value;
    params['intersects_geom'] = projectDefaultIsochrone().minified;
    value = 'doctors';
  }
  return new Promise(resolve => {
    axios
      .get(`${process.env.VUE_APP_API_URL}/${value}`, { params })
      .then(response => {
        const copyData = JSON.parse(JSON.stringify(response));
        const dupMarkersLngLat = copyData.data
          .map((obj: Record<string, string | number>) => `${obj.lat}, ${obj.lng}`)
          .filter((v: string, i: number, vIds: Record<string, any>) => vIds.indexOf(v) !== i);
        const dupMarkers = copyData.data.filter((obj: Record<string, string | number>) =>
          dupMarkersLngLat.includes(`${obj.lat}, ${obj.lng}`)
        );
        const dupMarkersZones = dupMarkers.reduce(
          (r: any, v: any, i: number, a: any, k: number = v.lat) => ((r[k] || (r[k] = [])).push(v), r),
          {}
        );
        const otherMarkers = copyData.data.filter(
          (obj: Record<string, string | number>) => !dupMarkersLngLat.includes(`${obj.lat}, ${obj.lng}`)
        );
        const dupMarkersMerged: Record<string, any>[] = [];
        for (const dupMarkersZone in dupMarkersZones) {
          let num = 0.0001;
          dupMarkersZones[dupMarkersZone].forEach((dupMarker: Record<string, string | number>) => {
            dupMarker.lng = +dupMarker.lng + num;
            num += 0.0001;
            dupMarkersMerged.push(dupMarker);
          });
        }
        copyData.data = [...otherMarkers, ...dupMarkersMerged];
        resolve(copyData);
      })
      .catch(() => {
        resolve({ data: [] });
      });
  });
};

const getPopupInfo = async (param: any, id: any): Promise<any> => {
  return new Promise(resolve => {
    axios
      .get(`${process.env.VUE_APP_API_URL}/${param}/${id}`)
      .then((response: any) => {
        resolve(response);
      })
      .catch(() => {
        resolve({ data: [] });
      });
  });
};

const getGeoJson = async (value: string): Promise<any> => {
  return new Promise(resolve => {
    axios
      .get(`${process.env.VUE_APP_API_URL}/${value}`)
      .then((response: any) => {
        resolve(response);
      })
      .catch(() => {
        resolve({ data: [] });
      });
  });
};

const getObjectCounts = async (): Promise<any> => {
  const params: any = {};

  const isochrone = mapStore.filterPolygon || projectDefaultIsochrone().original;

  params['intersects_geom'] = JSON.stringify(isochrone.features[0].geometry);

  return new Promise(resolve => {
    axios
      .post(`${process.env.VUE_APP_API_URL}/object-counts/`, params)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(() => {
        resolve([]);
      });
  });
};

const getAirDna = async (): Promise<any> => {
  const params: any = {};

  if (mapStore.lastMarkerCoord.length) {
    params['intersects_geom'] = {
      type: 'Point',
      coordinates: mapStore.lastMarkerCoord
    };
  }

  return new Promise(resolve => {
    axios
      .get(`${process.env.VUE_APP_API_URL}/air-dnas/`, { params })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(() => {
        resolve([]);
      });
  });
};

const getFluxVision = async (): Promise<any> => {
  const params: any = {};

  if (mapStore.lastMarkerCoord.length) {
    params['intersects_geom'] = {
      type: 'Point',
      coordinates: mapStore.lastMarkerCoord
    };
  }

  return new Promise(resolve => {
    axios
      .get(`${process.env.VUE_APP_API_URL}/flux-visions/`, { params })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(() => {
        resolve([]);
      });
  });
};

export default { getObjectCounts, getPoints, getAirDna, getFluxVision, getPopupInfo, getGeoJson };
